// hooks/useStripeOnboardingStatus.ts
import { useQuery } from "@tanstack/react-query";
import { getStripeOnboardingStatus } from "../api/payments";

export const useStripeOnboardingStatus = () => {
  return useQuery({
    queryKey: ["stripeOnboardingStatus"],
    queryFn: getStripeOnboardingStatus,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    staleTime: 60000,
  });
};
